<template>
  <span class="d-flex pb-4">
    <v-file-input
      :placeholder="$t(`${resource}.${slotData.title || slotData.name}`)"
      v-model="item[slotData.form.name || slotData.name]"
      :accept="slotData.form.accept"
      :rules="[
        requiredIfNew,
        ...(slotData.form.rules || []),
        backEndValidation(slotData.form.name || slotData.name)
      ]"
      @change="file => fileToBase64(file)"
      show-size
      :class="{ 'hide-input': slotData.form.hideInput }"
    ></v-file-input>
    <ImageItem :src="src" height="71" width="127"></ImageItem>
  </span>
</template>

<script>
import ImageItem from "../items/ImageItem";
import { rules } from "../../../mixins/rules";
export default {
  name: "FileFormItem",
  mixins: [rules],
  components: { ImageItem },
  props: {
    resource: {
      type: String
    },
    slotData: {
      type: Object
    },
    item: {
      type: Object
    }
  },
  data: () => ({
    dialogFilePreview: false,
    src: ""
  }),
  methods: {
    fileToBase64(file) {
      let reader = new FileReader();
      // Read file content on file loaded event
      reader.onload = event => {
        this.src = event.target.result;
      };
      // Convert data to base64
      if (file && file instanceof Blob) {
        reader.readAsDataURL(file);
      } else {
        this.src = "";
      }
    },
    getSrc() {
      this.src = this.item[this.slotData.form.name || this.slotData.name] || "";
      this.item[this.slotData.form.name || this.slotData.name] = null;
    },
    requiredIfNew(val) {
      if (this.item.id) {
        return true;
      } else {
        return this.rules.required(val);
      }
    }
  },
  created() {
    this.getSrc();
  }
};
</script>

<style lang="scss" scoped>
.hide-input::v-deep {
  position: relative;
  flex: 0 0;
  .v-input__control {
    position: absolute;
    left: 32px;
    bottom: -3px;
    transform: translateY(100%);
    width: 100px;
  }
  .v-input__slot {
    display: none;
  }
}
</style>
